import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "../../components/ui/Header";
import Button from "../../components/ui/Button";
import Input from "../../components/ui/Input";

import TagsCrudTable from "./components/TagsCrudTable";
import TagFormModal from "./components/TagFormModal";
import DeleteConfirmModal from "../users-crud-management/components/DeleteConfirmModal";

import {
  getTagsService,
  createTagService,
  updateTagService,
  deleteTagService,
} from "../../redux/services/workshops_service";

import { toast } from "react-toastify";
import Select from "components/ui/Select";

const TagsCrudManagement = () => {
  const dispatch = useDispatch();
  const { tagsList, metaTags } = useSelector((state) => state.workshops);

  const [language, setLanguage] = useState("ar");
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);

  // ✅ الفلاتر (مع dash)
  const [filters, setFilters] = useState({
    "is-car": "",
    "is-product": "",
    is_workshop: "",
    is_emergency: "",
  });

  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [selectedTag, setSelectedTag] = useState(null);
  const [formMode, setFormMode] = useState("add");

  // ✅ بناء params كـ object (مهم جداً)
  const buildParams = () => {
    const params = { page };

    if (searchQuery) {
      params.search = searchQuery;
    }

    Object.keys(filters).forEach((key) => {
      if (filters[key] !== "") {
        params[key] = Number(filters[key]); // 🔥 تحويل لقيمة رقمية
      }
    });

    return params;
  };

  // ✅ جلب البيانات
  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "ar";
    setLanguage(savedLanguage);

    const params = buildParams();
    console.log("PARAMS:", params); // 🔍 تأكد

    dispatch(getTagsService(params));
  }, [dispatch, page, searchQuery, filters]);

  const labels = {
    title: { ar: "إدارة التاغات", en: "Tags Management" },
    add: { ar: "إضافة تاغ", en: "Add Tag" },
    search: { ar: "البحث عن تاغ...", en: "Search tags..." },
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />

      <main className="container mx-auto px-4 py-6">
        <h1 className="text-3xl font-semibold mb-6">
          {labels.title[language]}
        </h1>

        {/* 🔹 البحث + الفلاتر */}
        <div className="bg-card rounded-xl p-6 shadow border mb-8 flex flex-col gap-4">
          <div className="flex justify-between gap-4">
            <Input
              placeholder={labels.search[language]}
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setPage(1);
              }}
            />

            <Button
              onClick={() => {
                setFormMode("add");
                setSelectedTag(null);
                setIsFormModalOpen(true);
              }}
            >
              {labels.add[language]}
            </Button>
          </div>

          {/* 🔹 الفلاتر */}
          <div className="flex gap-3 flex-wrap">
            <Select
              //label="Car Tags"
              options={[
                { value: "", label: "السيارات (الكل)" },
                { value: "1", label: "نعم" },
                { value: "0", label: "لا" },
              ]}
              value={filters["is-car"]}
              onChange={(v) =>
                setFilters((prev) => ({
                  ...prev,
                  "is-car": v,
                }))
              }
            />

             <Select
           //   label="Products Tags"
              options={[
                { value: "", label: "المنتجات (الكل)" },
                { value: "1", label: "نعم" },
                { value: "0", label: "لا" },
              ]}
              value={filters["is-product"]}
              onChange={(v) =>
                setFilters((prev) => ({
                  ...prev,
                  "is-product": v,
                }))
              }
            />

                  <Select
            //  label="WorkShop Tags"
              options={[
                { value: "", label: "الورش (الكل)" },
                { value: "1", label: "نعم" },
                { value: "0", label: "لا" },
              ]}
              value={filters["is-workshop"]}
              onChange={(v) =>
                setFilters((prev) => ({
                  ...prev,
                  "is-workshop": v,
                }))
              }
            />


        <Select
              label=""
              options={[
                { value: "", label: "الطوارىْ  (الكل)" },
                { value: "1", label: "نعم" },
                { value: "0", label: "لا" },
              ]}
              value={filters["is-emergency"]}
              onChange={(v) =>
                setFilters((prev) => ({
                  ...prev,
                  "is-emergency": v,
                }))
              }
            />
      

        


            {/* 🔥 Reset */}
            <Button
              onClick={() => {
                setFilters({
                  "is-car": "",
                  "is-product": "",
                  "is-workshop": "",
                  "is-emergency": "",
                });
                setSearchQuery("");
                setPage(1);
              }}
            >
              إلغاء الفلاتر
            </Button>
          </div>
        </div>

        <TagsCrudTable
          tags={tagsList}
          metaTags={metaTags}
          language={language}
          onPageChange={setPage}
          onEdit={(tag) => {
            setSelectedTag(tag);
            setFormMode("edit");
            setIsFormModalOpen(true);
          }}
          onDelete={(tag) => {
            setSelectedTag(tag);
            setIsDeleteModalOpen(true);
          }}
        />

        {isFormModalOpen && (
          <TagFormModal
            isOpen
            tag={selectedTag}
            mode={formMode}
            onClose={() => setIsFormModalOpen(false)}
            onSave={(data) => {
              if (formMode === "add") {
                dispatch(createTagService(data)).then(() => {
                  toast.success("تمت الإضافة بنجاح");
                  dispatch(getTagsService(buildParams()));
                  setIsFormModalOpen(false);
                });
              } else {
                dispatch(
                  updateTagService({
                    id: selectedTag.id,
                    formData: data,
                  }),
                ).then(() => {
                  toast.success("تم التحديث بنجاح");
                  dispatch(getTagsService(buildParams()));
                  setIsFormModalOpen(false);
                });
              }
            }}
          />
        )}

        {isDeleteModalOpen && (
          <DeleteConfirmModal
            isOpen
            itemName={selectedTag?.name}
            language={language}
            onClose={() => setIsDeleteModalOpen(false)}
            onConfirm={() => {
              dispatch(deleteTagService(selectedTag.id)).then(() => {
                toast.success("تم الحذف بنجاح");
                dispatch(getTagsService(buildParams()));
                setIsDeleteModalOpen(false);
              });
            }}
          />
        )}
      </main>
    </div>
  );
};

export default TagsCrudManagement;
